
import {
	Typography,
	RadioGroup,
	InputBase,
	Container,
	Toolbar,
	Divider,
	Button,
	AppBar,
	Drawer,
	alpha,
	Menu,
	Grid,
	Box,
} from '@mui/material'
import { styled } from '@mui/styles'

///// Home Outer Components
export const HomeWrapper = styled(Box)(({ theme }) => ({
	fontFamily: theme.typography.fontFamily,
	marginTop: theme.spacing(-10),
}))

///// TopBar
export const TopBarWrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.ud.primary.main,
	[theme.breakpoints.up('lg')]: {
		backgroundColor: theme.palette.background.paper,
	},
	padding: theme.spacing(0.25, 0),
}))
export const ContainerWrapper = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	justifyContent: 'flex-end',
	gap: theme.spacing(2.5),
	alignItems: 'center',
	display: 'flex',
	flexDirection: 'column',
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'row',
	}
}))
///// Search Component
export const SearchWrapper = styled('div')(({ theme }) => ({
	borderRadius: theme.shape.borderRadius,
	marginTop: theme.spacing(2),
	border: '1px solid #D4D2D2',
	backgroundColor: '#F7F7F7',
	position: 'relative',
	'&:hover': {
		backgroundColor: '#F5F5F5',
	},
	width: '100%',
	[theme.breakpoints.up('lg')]: {
		marginTop: 0,
		width: 'auto',
	},
}))
export const StyledInputBase = styled(InputBase)(({ theme }) => ({
	color: 'inherit',
	width: '100%',
	'& .MuiInputBase-input': {
		padding: theme.spacing(1, 0, 1, 1),
		// vertical padding + font size from searchIcon
		paddingRight: `calc(1em + ${theme.spacing(3)})`,
		transition: theme.transitions.create('width'),
		[theme.breakpoints.up('lg')]: {
			width: '12ch',
			'&:focus': {
				width: '20ch',
			},
		},
	},
}))
export const SearchIconWrapper = styled('div')(({ theme }) => ({
	padding: theme.spacing(0, 1),
	justifyContent: 'center',
	pointerEvents: 'none',
	alignItems: 'center',
	position: 'absolute',
	display: 'flex',
	height: '100%',
	right: 0,
	top: 0,
	'& svg': { fill: '#9F9F9F' }
}))
///// Language
export const LanguageSwitch = styled(Button)(({ theme }) => ({
	borderRadius: theme.spacing(0.5),
	backgroundColor: '#F4F4F4',
	'&:hover': {
		backgroundColor: '#F6F6F6',
	},
	textTransform: 'unset',
	gap: theme.spacing(1),
	textAlign: 'center',
	color: '#181818',
	minWidth: '100%',
	padding: 0,
	[theme.breakpoints.up('lg')]: {
		minWidth: theme.spacing(6.25),
		padding: theme.spacing(1, 2),
	}
}))

///// Theme
export const ThemeWrapper = styled(Box)(({ theme }) => ({
	color: theme.palette.common.white,
	gap: theme.spacing(1),
	alignItems: 'center',
	display: 'flex',
	'& svg': {
		fill: theme.palette.common.white,
		[theme.breakpoints.up('lg')]: {
			fill: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey['600'],
		},
	},
}))

///// Apps Icons
export const ButtonsWrapper = styled(Box)(({ theme }) => ({
	alignItems: 'center',
	display: 'flex',

	'& .MuiButton-root': {
		color: theme.palette.common.black,
		borderRadius: theme.spacing(0.5),
		paddingInline: theme.spacing(1),
		minWidth: theme.spacing(3.5),
		height: theme.spacing(3.5),

		'&.MuiButton-contained': {
			borderColor: theme.palette.mode === 'dark' ? theme.palette.grey['200'] : '#D9D9D9',
			backgroundColor: '#D9D9D9',
		},
		'&.MuiButton-outlined': {
			borderColor: theme.palette.mode === 'dark' ? theme.palette.grey['200'] : theme.palette.common.black,
			backgroundColor: theme.palette.common.white,
		}
	},
}))
export const VolumeMenu = styled(Menu)(({ theme }) => ({
	'& .MuiMenu-paper': {
		paddingInline: theme.spacing(2),
		minWidth: 200,
		'& .MuiStack-root': { marginBottom: 0 },
		'& .MuiSlider-thumb, & .MuiSlider-track': {
			backgroundColor: theme.palette.ud.primary.main
		},
	},
}))

///// Header
export const HeaderWrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
}))
export const HeaderContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	justifyContent: 'space-between',
	paddingBlock: theme.spacing(1),
	alignItems: 'center',
	display: 'flex',
}))
export const HeaderTitle = styled(Box)(() => ({
	textAlign: 'center',
}))
export const Title1 = styled(Typography)(({ theme }) => ({
	fontSize: theme.typography.fontSize,
	color: theme.palette.grey['50'],
	[theme.breakpoints.up('lg')]: {
		fontSize: theme.typography.fontSize * 1.4,
		color: theme.palette.mode === 'dark' ? theme.palette.grey['100'] : '#191B20',
	},
}))
export const Title2 = styled(Typography)(({ theme }) => ({
	fontWeight: theme.typography.fontWeightBold,
	fontSize: theme.typography.fontSize,
	color: theme.palette.grey['100'],
	[theme.breakpoints.up('lg')]: {
		fontSize: theme.typography.fontSize * 1.6,
		color: theme.palette.mode === 'dark' ? theme.palette.grey['50'] : '#0C0D10'
	},
}))

///// Navigation Menu
export const MenuWrapper = styled(AppBar)(({ theme }) => ({
	backgroundColor: theme.palette.ud.primary.main,
	color: theme.palette.ud.primary.text,
}))
export const NavContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	minHeight: theme.spacing(6.25),

	[theme.breakpoints.up('lg')]: {
		color: theme.palette.common.black,
		backgroundColor: 'transparent',
		minHeight: theme.spacing(5),
	},

	backgroundColor: theme.palette.ud.primary.main,
	color: theme.palette.ud.primary.text,
}))
export const NavToolbar = styled(Toolbar)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	justifyContent: 'space-between',
	padding: theme.spacing(0.5, 0),
	[theme.breakpoints.up('lg')]: {
		padding: theme.spacing(1, 0),
		justifyContent: 'center',
	},
	minHeight: theme.spacing(4),
	columnGap: theme.spacing(1),
	textAlign: 'center',
}))
export const StyledMenu = styled(Menu)(({ theme }) => ({
	'& .MuiMenu-paper': {
		backgroundColor: theme.palette.ud.primary.main,
		borderRadius: theme.shape.borderRadius * .75,
		translateY: theme.spacing(0.5),
		minWidth: 140,

		'& .MuiButton-root': {
			paddingInline: theme.spacing(2),
			textAlign: 'left',
			display: 'block',
			width: '100%',
		}
	}
}))
export const MenuItem = styled(Button)(({ theme }) => ({
	borderRadius: theme.shape.borderRadius * 0.5,
	color: theme.palette.primary.contrastText,
	paddingBlock: theme.spacing(0.25),
}))
export const StyledDivider = styled(Divider)(({ theme }) => ({
	height: theme.spacing(3.25) + ' !important',
	color: theme.palette.grey['50'],
	alignSelf: 'center',
}))
export const StyledDrawer = styled(Drawer)(({ theme }) => ({
	'& .MuiDrawer-paper': {
		backgroundColor: theme.palette.ud.primary.main,
		boxSizing: 'border-box',
		overflow: 'hidden',
		'& .subMenu': {
			backgroundColor: alpha(theme.palette.common.black, 0.1),
			paddingInline: theme.spacing(2),

			'& .MuiButton-root': {
				display: 'block',
				textAlign: 'left',
				width: '100%',
			}
		},
		'& .MuiButton-root': {
			paddingInline: theme.spacing(2),
			justifyContent: 'space-between',
			lineHeight: theme.spacing(5),
			borderRadius: 0,
			'&.MuiButton-contained, &.MuiButton-outlined': {
				paddingInline: theme.spacing(3),
			},
			'&.MuiButton-outlined': {
				borderColor: alpha(theme.palette.common.black, 0.1),
			}
		},
		'& .MuiDivider-vertical': {
			height: '1px !important',
			display: 'block',
			width: '100%',
		},
	}
}))

///// Hero Section
export const HeroWrapper = styled(Box)(({ theme, bgimg }) => ({
	background: `${theme.palette.grey['200']} url('${bgimg}') center center / cover no-repeat`,
	transition: `background 1.5s ease-in-out`,
	minHeight: `calc(100dvh - 50px)`,
	position: 'relative',

	[theme.breakpoints.up('lg')]: {
		minHeight: `calc(100dvh - 150px)`, // updated height 225px to 150px till achar sanhita
	}
}))
export const HeroTopLeftMessage = styled(Box)(({ theme }) => ({
	backgroundColor: alpha(theme.palette.common.black, 0.25),
	fontWeight: theme.typography.fontWeightMedium,
	textShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.75)',
	inset: theme.spacing(4, 4, 'auto', 4),
	[theme.breakpoints.up('sm')]: {
		inset: theme.spacing(4, 'auto', 'auto', 4),
	},
	fontSize: theme.typography.fontSize * 1.4,
	color: theme.palette.common.white,
	borderRadius: theme.spacing(0.5),
	backdropFilter: 'blur(1px)',
	padding: theme.spacing(2),
	position: 'absolute',
}))
export const HeroMantriStrip = styled(Box)(({ theme }) => ({
	backgroundColor: alpha(theme.palette.common.black, 0.7),
	inset: theme.spacing('auto', 0, 2),
	color: theme.palette.common.white,
	padding: theme.spacing(3, 4),
	[theme.breakpoints.up('md')]: {
		padding: theme.spacing(3, 8),
	},
	[theme.breakpoints.up('lg')]: {
		padding: theme.spacing(3, 12),
	},
	backdropFilter: 'blur(1px)',
	position: 'absolute',
}))
export const PersonCard = styled(Grid)(({ theme }) => ({
	justifyContent: 'space-between',
	gap: theme.spacing(2),
	alignItems: 'center',
	display: 'flex',
}))
export const PersonPic = styled(Box)(({ theme }) => ({
	'& img': {
		objectFit: 'cover',
		display: 'block',
		height: 80,
		width: 80,
	}
}))
export const PersonDesc = styled(Box)(({ theme }) => ({
	fontSize: theme.typography.fontSize,
	color: theme.palette.common.white,
	flex: 1,

	'& strong': {
		fontWeight: theme.typography.fontWeightMedium,
		display: 'block',
	},
}))

///// Services
export const ServicesContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	paddingBlock: theme.spacing(4),
}))
export const ServiceGrid = styled(Grid)(({ theme }) => ({
	justifyContent: 'center',

	'& .MuiButtonBase-root': {
		fontWeight: theme.typography.fontWeightSemiBold,
		flexDirection: 'column',
		textAlign: 'center',
		width: '100%',
		flex: 1,

		'& img': {
			marginBottom: theme.spacing(1),
			display: 'block',
			margin: 'auto',
			maxWidth: 150,
		}
	}
}))

///// AppDetails
export const AppDetailsWrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.ud.primary.main,
	fontWeight: theme.typography.fontWeightMedium,
	color: theme.palette.ud.primary.text,
	paddingBlock: theme.spacing(3.75),
}))
export const AppDetailsContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
}))
export const AppDetailsHead = styled(Typography)(({ theme }) => ({
	fontWeight: theme.typography.fontWeightMedium,
	fontSize: theme.typography.fontSize * 2,
	marginBottom: theme.spacing(2),
	textTransform: 'uppercase',
}))
export const AppDetailsLabel = styled(Box)(({ theme }) => ({
	fontSize: theme.typography.fontSize * 1.5,
}))
export const AppDetailsValue = styled(Box)(({ theme }) => ({
	fontSize: theme.typography.fontSize * 6,
}))

///// Checklist and Feedback Form
export const FormsContainer = styled(Container)(({ theme }) => ({
	maxWidth: theme.breakpoints['lg'],
	paddingBlock: theme.spacing(3),
	flexDirection: 'column',
	alignItems: 'stretch',
	display: 'flex',

	[theme.breakpoints.up('md')]: {
		alignItems: 'flex-start',
		flexDirection: 'row',
	},

	'& > div': {
		flex: 1,
		textAlign: 'center',
		padding: theme.spacing(2, 3, 3),
		'&.feedbackForm': { paddingInline: 0 },
		[theme.breakpoints.up('md')]: {
			'&.feedbackForm': { padding: theme.spacing(2, 3, 3) },
			textAlign: 'right',
		},
		'& .title': {
			fontWeight: theme.typography.fontWeightSemiBold,
			fontSize: theme.typography.fontSize * 1.5,
			color: theme.palette.ud.primary.main,
			marginBottom: theme.spacing(1.5),
			textTransform: 'uppercase',
			textAlign: 'left',
		},
	}
}))
export const ChecklistWrapper = styled(Box)(({ theme }) => ({
	border: '1px solid #F7A143',
	marginInline: 'auto',
	maxWidth: 530,

	'& .content': {
		marginBottom: theme.spacing(2),
		textAlign: 'left',

		'& p': {
			fontSize: theme.typography.fontSize,
			marginBottom: theme.spacing(1),
		},
	},
	'& .MuiButton-root': {
		color: theme.palette.ud.primary.main,
		textTransform: 'unset',
	},
}))
export const FeedbackWrapper = styled(Box)(({ theme }) => ({
	padding: theme.spacing(0),
	textAlign: 'center',
	[theme.breakpoints.up('md')]: {
		textAlign: 'right',
	},
}))
export const FormContainer = styled(Box)(({ theme }) => ({
	marginInline: 'auto',
	textAlign: 'center',
	maxWidth: 530,
	[theme.breakpoints.up('md')]: {
		textAlign: 'left',
		marginRight: 0,
		maxWidth: 450,
	},
	'& button[type="submit"]': {
		width: '100%',
	},
	'&.tcp': {
		'& .title': {
			fontWeight: theme.typography.fontWeightSemiBold,
			fontSize: theme.typography.fontSize * 1.5,
			color: theme.palette.tcp.primary.main,
			marginBottom: theme.spacing(1.5),
			marginRight: theme.spacing(4),
			textTransform: 'uppercase',
			textAlign: 'center',
		},
		'& .MuiFormGroup-root': {
			'& label .MuiFormControlLabel-label, & label svg': {
				color: theme.palette.tcp.primary.main,
			},
			'& label svg': {
				fill: theme.palette.tcp.primary.main,
			},
			justifyContent: 'center',
			gap: theme.spacing(2),

			'& .MuiButtonBase-root': {
				padding: theme.spacing(1),
			},
		},
	}
}))
export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
	'& label': {
		'&.MuiFormControlLabel-root': { marginBottom: 0 },
		'& .MuiFormControlLabel-label': {
			fontWeight: theme.typography.fontWeightSemiBold,
			fontSize: theme.typography.fontSize * 1.1,
			color: theme.palette.ud.primary.main,
		},

		'& svg': {
			fill: theme.palette.ud.primary.main,
		}
	}
}))

///// Footer
export const FooterWrapper = styled('footer')(({ theme }) => ({
	backgroundColor: theme.palette.ud.primary.main,
	color: theme.palette.ud.primary.text,
	fontSize: theme.typography.fontSize,
	padding: theme.spacing(1),
	textAlign: 'center',
}))

export const TcpFooterWrapper = styled('footer')(({ theme }) => ({
	backgroundColor: theme.palette.tcp.primary.main,
	color: theme.palette.ud.primary.text,
	fontSize: theme.typography.fontSize,
	padding: theme.spacing(1),
	textAlign: 'center',
}))
